export function titlecasefromsnake() {
  return function (input: string) {
    const text = input.toLowerCase();
    const result = text.replace(/[_]/g, " ");
    return result.charAt(0).toUpperCase() + result.slice(1);
  };
}
